export function eventLocalDay(value: unknown): string {
  if (typeof value !== 'string' && !(value instanceof Date)) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${String(date.getFullYear())}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function eventRange(date: string, startTime: string, endTime: string) {
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
    !/^\d{2}:\d{2}$/.test(startTime) ||
    !/^\d{2}:\d{2}$/.test(endTime)
  )
    throw new Error('Informe data, início e fim da atividade.');
  const start = new Date(`${date}T${startTime}:00`);
  const end = new Date(`${date}T${endTime}:00`);
  if (eventLocalDay(start) !== date || !Number.isFinite(end.getTime()) || end <= start)
    throw new Error('O fim precisa ser posterior ao início, no mesmo dia.');
  return { startsAt: start.toISOString(), endsAt: end.toISOString(), date: start };
}
